import React, { useEffect, useState } from "react";
import { Card, Row, Col } from "antd";
import Four from "../../assets/Streamery logo.png";
import { REDIRECT_LEARNING, REDIRECT_COACHING } from "../../config";
import "./HomePageStyles.css"; // Assuming you have a CSS file for styles
const TraineryTrak2 = ({ data, applications }) => {
  const [availableApps, setAvailableApps] = useState([]);

  useEffect(() => {
    if (data?.sub_applications) {
      const names = data.sub_applications.map((app) => app.name);
      setAvailableApps(names);
    }
  }, [data]);

  const isAvailable = (name) => availableApps.includes(name);

  const handleRedirect = (name) => {
    if (name === "Trak Learning") {
      window.location.href = REDIRECT_LEARNING;
    } else if (name === "Trak Coaching") {
      window.location.href = REDIRECT_COACHING;
    } else {
      const targetUrl = data?.sub_applications?.find(
        (app) => app.name === name
      )?.url;
      if (targetUrl) window.location.href = targetUrl;
    }
  };

  const logos = [
    {
      name: "Trak Learning",
      logo: applications?.find((app) => app.name === "Trak Learning")
        ?.application_logo,
    },
    {
      name: "Trak Coaching",
      logo: applications?.find((app) => app.name === "Trak Coaching")
        ?.application_logo,
    },
    {
      name: "TraineryLMS",
      logo: applications?.find((app) => app.name === "TraineryLMS")
        ?.application_logo,
    },
    {
      name: "Streamery",
      logo: Four,
    },
  ];
  const handleKnowMore = (name) => {
    // You can customize this action (e.g., open a modal, redirect, etc.)
    window.open("https://trainery.com/contact", "_blank");
  };
  return (
    <div style={{ width: "90%", margin: "0 auto", marginTop: 35 }}>
      <Card
        bordered={false}
        style={{ borderRadius: 16, overflow: "hidden" }}
        title={
          <div className="moving-gradient-header">
            <span>TRAINERY LEARN</span>
          </div>
        }
        headStyle={{
          padding: 0,
          borderBottom: "none",
        }}
        bodyStyle={{
          padding: 24,
        }}
      >
        <Row gutter={[18, 18]}>
          {logos.map(({ name, logo }) => {
            const available = isAvailable(name);
            return (
              <Col xs={24} sm={12} key={name}>
                <div
                  onClick={() => available && handleRedirect(name)}
                  className={`logo-card-item ${
                    available ? "available" : "unavailable"
                  }`}
                  style={{
                    position: "relative",
                    cursor: available ? "pointer" : "not-allowed",
                  }}
                >
                  <img src={logo} alt={name} />
                  {!available && (
                    <div
                      className="logo-card-hover-message"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleKnowMore(name);
                      }}
                    >
                      <span>
                        You don't have access.
                        <br />
                        <span
                          style={{
                            color: "#1677ff",
                            // textDecoration: "underline",
                          }}
                        >
                          Click to know more
                        </span>
                      </span>
                    </div>
                  )}
                </div>
              </Col>
            );
          })}
        </Row>
      </Card>
    </div>
  );
};

export default TraineryTrak2;
